import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'signalsAddress'})
export class SignalsAddressPipe implements PipeTransform {
	transform(address: string): string {
		return (address.length == 13)
			? (address.slice(0, 3) + '-' + address.slice(3, 8) + '-' + address.slice(8))
			: (address);
	}
}